import { createApp } from 'vue';
import App from './App.vue';
import vue3GoogleLogin from 'vue3-google-login'
import router from './router';
import './assets/tailwind.css';

// createApp(App).use(router).mount('#app');

const app = createApp(App)

app.use(vue3GoogleLogin, {
  clientId: '74952392717-799r54ja5j64ju03rd8oefh9ddglgkfq.apps.googleusercontent.com'
})

app.use(router)

app.mount('#app')